import { CustomerOrderItem } from "@omni/types/api/cart/bff/shared/customerOrderItem.model";
import { ProductConfiguration } from "@omni/types/utils/productConfiguration";
import { Translate } from "@omni/types/utils/translate";
import { pick } from "lodash-es";

export const productIsAdditionalService = (
    items: Array<CustomerOrderItem>,
    id?: string
) => {
    return (
        !!id &&
        items.some((i) => i.additionalServices?.map((as) => as.id).includes(id))
    );
};

export const getTitle = (
    customerOrderItem: CustomerOrderItem,
    t: Translate
) => {
    const name = customerOrderItem.name;
    const brandName = customerOrderItem.brandName;

    if (customerOrderItem.warrantyDeposit) {
        return t("general.product.pallet.title");
    }

    if (customerOrderItem.articleConfiguration) {
        return customerOrderItem.articleConfiguration.title || "";
    }

    return brandName && name ? `${brandName} ${name}` : name || "";
};

export const getUrl = (
    customerOrderItem: CustomerOrderItem,
    giftcardPage: string
) => {
    if (customerOrderItem.giftCardArticle) {
        return giftcardPage;
    } else if (customerOrderItem.articleConfiguration) {
        return undefined;
    }

    return customerOrderItem.productUrl;
};

export const getConfiguration = (
    customerOrderItem: CustomerOrderItem,
    productConfigurations: Array<ProductConfiguration>
) => {
    return pick(
        customerOrderItem,
        productConfigurations.reduce(
            (acc, pc) => [...acc, ...pc.configPaths],
            [] as string[]
        )
    );
};
